import { render, staticRenderFns } from "./CandidateWallet.vue?vue&type=template&id=2b073987&scoped=true"
import script from "./CandidateWallet.vue?vue&type=script&lang=js"
export * from "./CandidateWallet.vue?vue&type=script&lang=js"
import style0 from "./CandidateWallet.vue?vue&type=style&index=0&id=2b073987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b073987",
  null
  
)

export default component.exports